import { ArticleV3 } from '~/declarations/toggle-api-news';

export const isInsightFromUS = (a: Pick<ArticleV3, 'eco'>) => a.eco === 'us';
